import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is Beemamen?",
    a: "Beemamen is a general insurance services company helping individuals and businesses choose the right insurance — car, health, truck, travel, tractor and more — from India's top IRDAI-licensed insurers.",
  },
  {
    q: "Do you charge any fee for advice?",
    a: "No. Our advisory service is completely free. You only pay the actual premium of the policy you choose. We earn a standard commission from the insurer, not from you.",
  },
  {
    q: "How fast can I get a policy?",
    a: "Most motor and travel policies are issued instantly. Health policies are usually issued within 24 hours, depending on the medical declarations.",
  },
  {
    q: "Can I get cashless hospitalisation under health insurance?",
    a: "Yes. All our recommended health insurance partners offer cashless hospitalisation at thousands of network hospitals across India.",
  },
  {
    q: "Will Beemamen help me at the time of claim?",
    a: "Absolutely. Claim hand-holding is the core of our service. From document submission to follow-ups — our team works with the insurer on your behalf.",
  },
  {
    q: "How do I contact Beemamen?",
    a: "Call us at +91 8827794458 or +91 9826982244, or email support@beemamen.com. You can also fill the quote form on this page and we will call you back.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center">
          <span className="eyebrow">FAQ</span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Got questions? <span className="text-[#1e3a8a]">We have answers.</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-slate-200 rounded-2xl px-5 bg-white hover:border-[#f5b942] transition-colors"
            >
              <AccordionTrigger className="text-left font-display font-bold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
